import React from 'react';
import SectionCard from './SectionCard';
import {Card} from "react-bootstrap";
import {useLanguage} from "../LanguageContext";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import PhotoSlider from "./ImageSlider";
import ImageSlider from "./ImageSlider";

const Service = () => {

    const { translations } = useLanguage();
    return (
        <Card className="section-card">
            <Card.Body>
                <Card.Title>
                    <h1 style={{ margin: "5px" }}>{translations.service.title}</h1>
                </Card.Title>
                <Card.Text>
                    <div style={{margin : "15px", marginTop: "5px"}}>
                        <ImageSlider />
                    </div>

                    <div className="row" style={{margin: "15px"}}>
                        <div>{translations.service.subTitle}</div>
                    </div>
                    <div className="row" style={{margin: "15px"}}>
                        <h2 style={{ margin: "5px" }}>{translations.service.mixingTitle}</h2>
                        <div style={{margin : "5px"}}>{translations.service.mixingContent}</div>
                    </div>
                    <div className="row" style={{margin: "15px"}}>
                        <h2 style={{ margin: "5px" }}>{translations.service.productionTitle}</h2>
                        <div style={{margin : "5px"}}>{translations.service.productionContent}</div>
                    </div>
                    <div className="row" style={{margin: "15px"}}>
                        <h2 style={{ margin: "5px" }}>{translations.service.masteringTitle}</h2>
                        <div style={{margin : "5px"}}>{translations.service.masteringContent}</div>
                    </div>
                    <div className="row" style={{ margin: "15px" }}>
                        <h2>{translations.service.descriptionTitle}</h2>
                        <div style={{margin : "5px"}}>
                            <ul>
                                <li><i className="bi bi-check-circle"></i> {translations.service.descriptionPointOne}</li>
                                <li><i className="bi bi-check-circle"></i> {translations.service.descriptionPointTwo}</li>
                                <li><i className="bi bi-check-circle"></i> {translations.service.descriptionPointThree}</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div><b>{translations.service.footer}</b></div>
                    </div>
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

export default Service;